module.exports = __webpack_public_path__ + "img/bankB-gold.017d3996.svg";